<template>
  <div class="normal j-header">
    <lang-nav></lang-nav>
    <div class="nav-container">
        <div class="nav-box">
          <div class="logo-box">
            <router-link class="logo" :to="{name: 'home'}">
              <img src="../assets/logo_01.png" width="220" height="74" alt="">
            </router-link>
          </div>
          <div class="m-nav">
            <ul>
              <li class="j-icon icon-menu" @click="viewMenu = !viewMenu" :class="{'menu-open': viewMenu}">
                <a href="javascript:;" >
                  <span class="menu-span"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="nav-bar m-hidden">
          <div class="vertical">
            <search-area></search-area>
          </div>
        </div>
      </div>
    <nav-item class="m-hidden"></nav-item>
    <transition name="m-header">
      <div v-show="viewMenu" class="m-menu">
        <div class="nav-bar">
          <div class="vertical">
            <search-area></search-area>
          </div>
        </div>
        <nav-item></nav-item>
      </div>
    </transition>
  </div>
</template>

<script>
  import LangNav from '../components/header/LangNav.vue'
  import SearchArea from '../components/header/SearchArea.vue'
  import NavItem from '../components/header/Nav.vue'
  export default {
    components: {
      LangNav, SearchArea, NavItem
    },
    data () {
      return {
        viewMenu: false
      }
    },
    watch: {
      $route () {
        if (this.viewMenu) {
          this.viewMenu = false
        }
        Velocity(document.querySelector('body'), 'scroll', {
          duration: 500,
          offset: top
        })
      }
    }
  }
</script>
<style type="text/scss" lang="scss" rel="stylesheet/scss">
  @import "../styles/declaration";
  .j-header {
    width: 100%;
    min-width: $min-width;
    background-color: #fcfcfc;
    border-bottom: none;
    .nav-container {
      max-width: 1200px;
      margin: auto;
    }
    .nav-box {
      display: table-cell;
      width: 225px;
    }
    .logo-box a {
      @extend .nav-box;
      text-align: center;
      vertical-align: middle;
      height: 130px;
      padding: 0 10px;
    }
    .nav-bar {
      display: table-cell;
      vertical-align: middle;
      width: 100%;
    }
    .child-nav {
      margin-top: 0;
    }
    .list {
      text-align: right;
      font-size: 0;
      word-spacing: -1em;
      li {
        display: inline-block;
        margin-right: 0;
      }
      .selected {
        border-color: #f01b00 !important;
      }
      a {
        padding: 4px 10px 9px;
        font-size: $font-size + .05rem;
        color: #3366cc;
        background-color: transparent;
      }
    }
    .search-area .input-search {
      height: 32px;
      width: 450px;
      letter-spacing: .035rem;
      border: 1px solid #9b9b9b;
      border-radius: 0;
      background-color: #ffffff;
    }
    .input-search::-webkit-input-placeholder
    {
      padding-left: 10px;
      font-style: italic;
    }
    .j-btn a {
      position: relative;
      font-size: $font-size + .05rem;
      display: block;
      padding: 10px 50px 10px;
      color: #ffffff;
      background-color: #5e5e5e;
      &::before {
        content: ' ';
        position: absolute;
        top: 0;
        left: 20px;
        bottom: 0;
        width: 30px;
        height: 30px;
        margin: auto;
        background: url('../assets/icons/contact.png') 50% 50% no-repeat;
        background-size: contain;
      }
    }
    .icon-rfi a {
      padding-left: 40px;
      /*background-image: url(../assets/icons/icon_list.png);*/
      background-position: 13px 50%;
    }
    .m-nav, .nav-btn {
      display: none;
      padding-left: 30px;
      vertical-align: top;
    }
    .m-nav .j-icon {
      display: inline-block;
    }
    .nav-btn {
      background-color: transparent;
      border: 1px solid #999;
      border-radius: 4px;
      padding: 0 6px;
      outline: none;
      height: 35px;
      top: 0;
      bottom: 0;
      right: .5rem;
      margin: auto;
      position: absolute;
      span {
        width: 22px;
        height: 2px;
        display: block;
        margin: 4px 0;
        background-color: #999;
      }
      span:nth-child(2) {
        margin: 0;
      }
    }
    &.fixed {
      position: fixed;
      .logo-box a {
        height: 105px;
      }
      .nav-bar {
        padding-top: 15px;
      }
    }
  }
  @media screen and (max-width: 767px){
    .logo-box .logo img{
      height: 100%;
    }
    .m-hidden{
      display: none;
      &.nav-bar{
        display: none;
      }
    }
    .m-menu{
      width: 100%;
      position: relative;
      /*top: 60px;*/
      z-index: 5;
      .nav-bar{
        display: block;
      }
    }
  }
  // @media screen and (min-width: 768px) {
  //   .j-header .nav-bar {
  //     min-width: 1000px;
  //   }
  // }
  // @media screen and (max-width: 1319px){
  //   .j-header {
  //     min-width: 0;
  //   }
  // }
</style>
<style type="text/scss" lang="scss" rel="stylesheet/scss">
  @import "../styles/m-header";
</style>



// WEBPACK FOOTER //
// src/components/Header.vue